import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { apiUrl } from "../../global/global";
import { ImageUrls } from "src/app/services/s3buket";
import { LastStepperService } from "src/app/services/last-stepper/last-stepper.service";
import { number } from "echarts";

@Component({
  selector: "app-jobs",
  templateUrl: "./jobs.component.html",
  styleUrls: ["./jobs.component.css"]
})
export class JobsComponent implements OnInit {
  isPreferences;
  jobsData: any = {};
  recruiterImagePath = ImageUrls.BaseUrl + ImageUrls.directories.recruiter;
  constructor(public route: ActivatedRoute, private router: Router, private api: AdminService,
    private lastStepperService: LastStepperService) {
    this.lastStepperService.lastStepperObserver.subscribe(stepper => {
      if (stepper) {
        this.getAllJobs(stepper.isPreferences);
      }
    });
  }
  ngOnInit(): void { }

  ngAfterViewInit() {
    this.api.setSearch('');
  }

  getAllJobs(isPreferencesCompleted: number) {
    this.isPreferences = isPreferencesCompleted;
    this.api.getData(isPreferencesCompleted == 1 ? apiUrl._dashboardForActiveUser : apiUrl._dashboardForGuestUser, {})
      .subscribe((res) => {
        this.jobsData = res.data;
      }, (err) => { console.log(err.error.message, "error"); });
  }

  onJobSaved(job: any) {
    job.saveStatus = job.saveStatus == 1 ? 0 : 1;
  }

  openEmployerDetails(employerId) {
    this.router.navigate(["/employer-choice/details/" + employerId + "/about"]);
  }
}